(function () {
  'use strict';

  // ============================================================
  // MINDSTATE Cookie Banner
  // - Customer Privacy API integration
  // - Region detection (EU only by default)
  // - localStorage persistence
  // ============================================================

  var STORAGE_KEY = 'mindstate_cookie_consent_v1';
  var CONSENT_VERSION = 1;
  
  // EU country codes (ISO 3166-1 alpha-2) where banner must show
  var EU_COUNTRIES = [
    'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR',
    'HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK',
    'SI','ES','SE',
    // EEA + UK
    'IS','LI','NO','GB','CH'
  ];

  var banner, defaultView, customizeView;

  // ============================================================
  // INIT
  // ============================================================
  function init() {
    banner = document.getElementById('ms-cookie-banner');
    if (!banner) return;
    
    defaultView = banner.querySelector('[data-view="default"]');
    customizeView = banner.querySelector('[data-view="customize"]');
    
    // Bind action buttons (event delegation on banner)
    banner.addEventListener('click', handleClick);

    // Check if user already consented
    var stored = readStoredConsent();
    if (stored) {
      applyConsent(stored.choices, false); // apply silently, dont show banner
      return;
    }

    // No prior consent -- should we show?
    if (!shouldShowBanner()) {
      return;
    }

    showBanner();
  }

  // ============================================================
  // STORAGE
  // ============================================================
  function readStoredConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (parsed.version !== CONSENT_VERSION) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function storeConsent(choices) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        version: CONSENT_VERSION,
        timestamp: Date.now(),
        choices: choices
      }));
    } catch (e) {
      // localStorage unavailable (private mode etc) -- silently fail
    }
  }

  // ============================================================
  // REGION DETECTION
  // ============================================================
  function shouldShowBanner() {
    // Try Shopify object
    var country = '';
    try {
      if (window.Shopify && window.Shopify.country) {
        country = String(window.Shopify.country).toUpperCase();
      } else if (window.Shopify && window.Shopify.locale) {
        // Locale format: "pl", "pl-PL", "en-GB" -- extract country
        var locale = String(window.Shopify.locale);
        var parts = locale.split('-');
        if (parts.length > 1) country = parts[1].toUpperCase();
        else country = parts[0].toUpperCase();
        // Map common locales to country
        var localeMap = { PL: 'PL', EN: '', DE: 'DE', FR: 'FR', IT: 'IT', ES: 'ES' };
        if (localeMap[country] !== undefined) country = localeMap[country];
      }
    } catch (e) {}
    
    // Default behavior: if no country detected, show banner (safer side)
    if (!country) return true;
    
    // Show only if EU
    return EU_COUNTRIES.indexOf(country) !== -1;
  }

  // ============================================================
  // SHOW / HIDE
  // ============================================================
  function showBanner() {
    banner.setAttribute('data-state', 'visible');
    banner.setAttribute('aria-hidden', 'false');
    // Default view shown by default in HTML
  }

  function hideBanner() {
    banner.setAttribute('data-state', 'hidden');
    banner.setAttribute('aria-hidden', 'true');
  }

  function showCustomizeView() {
    defaultView.setAttribute('hidden', '');
    customizeView.removeAttribute('hidden');
  }

  function showDefaultView() {
    customizeView.setAttribute('hidden', '');
    defaultView.removeAttribute('hidden');
  }

  // ============================================================
  // CLICK HANDLERS
  // ============================================================
  function handleClick(e) {
    var target = e.target.closest('[data-action]');
    if (!target) return;
    var action = target.getAttribute('data-action');

    if (action === 'accept-all') {
      var choices = { analytics: true, marketing: true, preferences: true };
      finalize(choices);
    } else if (action === 'reject') {
      var choices = { analytics: false, marketing: false, preferences: false };
      finalize(choices);
    } else if (action === 'customize') {
      showCustomizeView();
    } else if (action === 'back') {
      showDefaultView();
    } else if (action === 'save') {
      var choices = readToggleStates();
      finalize(choices);
    }
  }

  function readToggleStates() {
    var inputs = customizeView.querySelectorAll('input[data-consent]');
    var result = {};
    for (var i = 0; i < inputs.length; i++) {
      var category = inputs[i].getAttribute('data-consent');
      result[category] = !!inputs[i].checked;
    }
    return result;
  }

  function finalize(choices) {
    storeConsent(choices);
    applyConsent(choices, true);
    hideBanner();
  }

  // ============================================================
  // APPLY CONSENT TO SHOPIFY API
  // Uses Shopify.loadFeatures() to lazy-load Customer Privacy API
  // (per official Shopify docs: shopify.dev/docs/api/customer-privacy)
  // ============================================================
  function applyConsent(choices, isUserAction) {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      // Shopify global not ready yet -- retry once after delay
      setTimeout(function () {
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          loadAndApply(choices);
        }
      }, 1500);
      return;
    }
    loadAndApply(choices);
  }

  function loadAndApply(choices) {
    try {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (error) {
            if (window.console && console.warn) {
              console.warn('[ms-cookie] loadFeatures error:', error);
            }
            return;
          }
          callShopifyAPI(choices);
        }
      );
    } catch (e) {
      if (window.console && console.warn) {
        console.warn('[ms-cookie] loadFeatures threw:', e);
      }
    }
  }

  function callShopifyAPI(choices) {
    if (!window.Shopify || !window.Shopify.customerPrivacy || typeof window.Shopify.customerPrivacy.setTrackingConsent !== 'function') {
      if (window.console && console.warn) {
        console.warn('[ms-cookie] customerPrivacy.setTrackingConsent not available after loadFeatures');
      }
      return;
    }
    try {
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: !!choices.analytics,
        marketing: !!choices.marketing,
        preferences: !!choices.preferences,
        sale_of_data: !!choices.marketing
      }, function (err) {
        if (err && window.console && console.warn) {
          console.warn('[ms-cookie] setTrackingConsent error:', err);
        }
      });
    } catch (e) {
      if (window.console && console.warn) {
        console.warn('[ms-cookie] setTrackingConsent threw:', e);
      }
    }
  }

  // ============================================================
  // BOOT
  // ============================================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
